import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const InsetPanel = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.02),
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  padding: theme.spacing(2),
  boxShadow: theme.customShadows.card,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3),
  },
}));
